import { useContext } from 'react';

import { TvPlanContext } from "../../contexts/tvplancontext";
import TvPlanPack from "../TvPlanPack";


function TvPlanFav(props) {
    const ctx = useContext(TvPlanContext)
    const code = props.code;
    let selected = false;

    let selToggle = () => {
    	ctx.selectFavExplicit(code);
    } 

    if (ctx.isFavSelected(code)) {
    	selected = true;
    	selToggle = () => { ctx.unselectFavExplicit(code);}
    }
    
    return (
        <TvPlanPack
            showSelected={false}
            onClick={props.onClick}
            onSelect={selToggle}
            selected={selected}
            code={code} />
    );
}


export default TvPlanFav;